export default __webpack_public_path__ + "static/media/Nergal's Lantern of the Burning Sky.349468eb.jpg";